import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=1937235a&scoped=true&"
import script from "./navigation.js?vue&type=script&lang=js&"
export * from "./navigation.js?vue&type=script&lang=js&"
import style0 from "./navigation.scss?vue&type=style&index=0&id=1937235a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937235a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
